import Select from "react-select";
import styles from "../CustomeSelectBox/customeSelectBox.styles.module.scss";
import { IProjectSelectBox } from "./type";
import { customSelectBoxStyles } from "../CustomeSelectBox/customSelectBoxStyles";

const LazySelectBox = (props: IProjectSelectBox) => {
  const { isRequired, label, placeholder, className, onSelect, option, disabled, isLoading, value, onScrollToBottom } = props
  return (
    <div className={`${styles.inputBox}`}>
      <label className="form-label">
        {label}
        {isRequired && <span className={styles.requiredSing}>*</span>}
      </label>
      <Select
        value={value}
        placeholder={placeholder}
        styles={customSelectBoxStyles}
        className={`${className ? styles[className] : ""} `}
        onChange={onSelect}
        options={option}
        isDisabled={disabled}
        isLoading={isLoading}
        onMenuScrollToBottom={onScrollToBottom}
      />
    </div>
  )
}

export default LazySelectBox;
